import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

interface AtlasPageProps {
    onShowAuth: () => void;
}

export const AtlasPage: React.FC<AtlasPageProps> = ({ onShowAuth }) => {
    const { user } = useAuth();

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data.type === 'SHOW_AUTH') {
                onShowAuth();
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [onShowAuth]);

    // Notify iframe of auth change
    useEffect(() => {
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage({
                type: 'AUTH_STATE_CHANGED',
                isLoggedIn: !!user
            }, '*');
        }
    }, [user]);

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                margin: 0,
                padding: 0,
                overflow: "hidden",
                background: "#fff",
                position: "relative",
            }}
        >
            <iframe
                src="/atlas/index.html"
                title="UPSC Atlas Tool"
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                }}
                onLoad={(e) => {
                    const iframe = e.currentTarget;
                    if (iframe.contentWindow) {
                        iframe.contentWindow.postMessage({
                            type: 'AUTH_STATE_CHANGED',
                            isLoggedIn: !!user
                        }, '*');
                    }
                }}
            />
        </div>
    );
};
